// Package imports
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { map, find, sortBy, findIndex, intersectionBy } from "lodash";
import Box from "@mui/material/Box";
import { Button } from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";

// Custom imports
import { assignmentSliceActions } from "../../Store/Slices/AssignSlice";
import { getClassLearners } from "./Services";
import SelectionList from "../../Components/List/SelectionList";
import { Typography } from "@mui/material";

// Global variables

// Component
function LearnersList() {
  // Hooks
  const dispatch = useDispatch();

  // State
  const [learners, setLearners] = useState([]);
  const [selectedAll, setSelectedAll] = useState(false);

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const { selectedClasses, selectedLearners } = useSelector((state) => state.assignment);

  // React logic hooks
  useEffect(() => {
    const innerFunction = async () => {
      let learnersData = await getClassLearners(
        map(selectedClasses, "id"),
        userInfo.site_uuid
      );
      setLearners(
        sortBy(withClassName(learnersData.data), [
          "classname",
          (o) => {
            return o.name.firstname;
          },
        ])
      );
    };
    innerFunction();
  }, [selectedClasses]);

  const withClassName = (learners) => {
    return learners.map((val) => {
      return {
        ...val,
        classname: className(val.belongs_to),
      };
    });
  };

  useEffect(() => {
    checkSelectAll();
  }, [selectedLearners, learners]);

  let checkSelectAll = () => {
    let interSect = learners.filter((val, ind) => {
      return findIndex(selectedLearners,{'id': val.uid}) > -1;
    })
    
    if (interSect && learners && learners.length > 0 && interSect.length == learners.length) {
      setSelectedAll(true);
    } else {
      setSelectedAll(false);
    }
  }

  // select learner from list
  const addInLearners = (value, name, belongs_to, status) => {
    console.log("DDDDDD",name);
    if (status) {
      dispatch(
        assignmentSliceActions.addLearner({
          id: value,
          name: name,
          belongs_to: belongs_to,
        })
      );
    } else {
      dispatch(assignmentSliceActions.removeLearner(value));
    }
  };

  const className = (id) => {
    let foundObj = find(selectedClasses, { id: id });
    if (foundObj) {
      return foundObj.value;
    }
    return "NA";
  };

  const selectAllClick = () => {
    learners.forEach((val) => {
      if (!selectedAll) {
        if (findIndex(selectedLearners, { id: val.uid }) == -1) {
          dispatch(
            assignmentSliceActions.addLearner({
              id: val.uid,
              name: `${val.name.firstname} ${val.name.lastname} - (${val.classname})`,
              belongs_to: val.belongs_to,
            })
          );
        }
      } else {
        dispatch(assignmentSliceActions.removeLearner(val.uid));
      }
    });
    setSelectedAll(!selectedAll);
  };

  // JSX template
  return (
    <>
      <Box>
        <Button
          variant="outlined"
          size="small"
          sx={{
            ml: 2,
            borderRadius: 15,
            backgroundColor: "#F5F5F5",
            color: "primary.main",
            height: "2rem",
            textTransform: "inherit",
            "@media (min-width: 1636px)": {
              fontSize: "1.4rem",
              height: "3rem",
            },
          }}
          onClick={selectAllClick}
        >
          <CircleIcon
            fontSize="small"
            value="a"
            name="radio-buttons"
            sx={{
              color: selectedAll ? "#5f5600ff" : "#D9D9D9",
              marginRight: 1,
            }}
          />
          Pick All
        </Button>
        {learners &&
          learners.length > 0 &&
          learners.map((obj, index) => {
            return (
              <div key={`${obj.uid}_learnerAssign`}>
                <SelectionList
                  title={`${obj.name.firstname} ${obj.name.lastname} - (${obj.classname})`}
                  value={obj.uid}
                  from="LearnerSelect"
                  checkTick={(val, name, status) => {
                    addInLearners(val, name, obj.belongs_to, status);
                  }}
                />
              </div>
            );
          })}
        {selectedClasses &&
          selectedClasses.length > 0 &&
          learners &&
          learners.length == 0 && (
            <Typography>No learners available!</Typography>
          )}
      </Box>
    </>
  );
}

export default LearnersList;
